import { Component, inject, OnInit } from '@angular/core';
import { GlobalStoreService } from '@services/global-store/global-store.service';
import { ParticulierMouvement } from '../../api/model/particulier-mouvement.model';
import { NavigationService } from '@services/navigation/navigation.service';
import { AccessibiliteService } from '@services/accessibilite.service';
import { GestionTitreService } from '@services/navigation/gestion-titre.service';
import { TelephoneMouvement } from 'src/app/api/model/telephone-mouvement.model';
import { AdresseMouvement } from 'src/app/api/model/adresse-mouvement.model';
import { TelephoneTypeLieuEnum } from 'src/app/constantes/telephone-type-lieu.enum';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../constantes/cybermetrie.enum';
@Component({
  selector: 'app-coordonnees',
  templateUrl: './coordonnees.component.html',
  standalone: false,
})
export class CoordonneesComponent implements OnInit {
  private readonly globalStoreService = inject(GlobalStoreService);
  private readonly navigationService = inject(NavigationService);
  private readonly gestionTitreService = inject(GestionTitreService);
  private readonly accessibiliteService = inject(AccessibiliteService);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);

  coordonneesParticulierMouvement: ParticulierMouvement | null = null;
  lightboxAffichee: boolean = false;
  planifierAppelCybermetrieLabel = CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_PLANIFIER_APPEL;
  extraAttributCybermetrie: string = '';

  ngOnInit(): void {
    this.gestionTitreService.addTitreOnglet('titreOnglet.coordonnees');
    this.globalStoreService.getCoordonneesMouvement$().subscribe({
      next: (data) => {
        this.coordonneesParticulierMouvement = data;
        this.extraAttributCybermetrie = this.cybermetrieExtraAttribut();
      },
    });
  }

  private cybermetrieExtraAttribut(): string {
    if (this.adressePostdatee) {
      return CybermetrieEnum.EXTRA_ATTRIBUT_ADRESSE_POSTDATEE;
    }
    if (!this.peutModifierAdresse) {
      return CybermetrieEnum.EXTRA_ATTRIBUT_ADRESSE_NON_MODIFIABLE;
    }
    return '';
  }

  get adresseCourante(): AdresseMouvement | undefined {
    return this.coordonneesParticulierMouvement?.adresseCourante;
  }

  get adressePostdatee(): AdresseMouvement | undefined {
    return this.coordonneesParticulierMouvement?.adressePostdatee;
  }

  get courriel(): string | undefined {
    return this.coordonneesParticulierMouvement?.courriel?.adresseCourriel;
  }

  get telephone(): TelephoneMouvement | undefined {
    return this.coordonneesParticulierMouvement?.telephones?.find(
      (tel) => tel.typeLieu === TelephoneTypeLieuEnum.RESIDENCE_PRINCIPALE,
    );
  }

  get afficherPostdatee(): boolean {
    return !!this.coordonneesParticulierMouvement?.adressePostdatee;
  }

  get peutModifierAdresse(): boolean {
    return this.coordonneesParticulierMouvement?.indicateurs?.indicateurAdresseModifiable ?? false;
  }

  allerAModificationCourriel() {
    this.navigationService.naviguerVersModifierCourriel();
    this.cybermetrieCoordonneesService.actionClick(
      this.courriel
        ? CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_COURRIEL_MODIFIER
        : CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_COURRIEL_AJOUTER,
    );
  }
  allerAModificationAdresse() {
    this.navigationService.naviguerVersModifierAdresse();
    this.cybermetrieCoordonneesService.actionClick(
      CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_ADRESSE,
    );
  }
  allerAModificationTelephone() {
    this.navigationService.naviguerVersModifierTelephone();
    this.cybermetrieCoordonneesService.actionClick(
      this.telephone
        ? CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_TELEPHONE_MODIFIER
        : CybermetrieEnum.LABEL_MODIFIER_COORDONNEES_TELEPHONE_AJOUTER,
    );
  }

  afficherLightboxInformation() {
    this.lightboxAffichee = true;
    this.cybermetrieCoordonneesService.actionClick(CybermetrieEnum.LABEL_MODIFIER_COORDONNEES);
  }

  cacherLightboxInformation() {
    this.lightboxAffichee = false;
    this.accessibiliteService.setFocus('#boutonInformation');
  }
}
